import React, { useRef } from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Inicio from '../components/sections/Inicio';
import Productos from '../components/sections/Productos';
import Contacto from '../components/sections/Contacto';
const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

const IndexPage = () => {
  const myRef = useRef(null)
  const executeScroll = () => scrollToRef(myRef)
  return (
    <Layout independiente={false}>
      <SEO title="Abstrahere" />
      <Inicio id="inicio" />
      <Productos id="productos" executeScroll={executeScroll} />
      <Contacto id="contacto" refProp={myRef} />
    </Layout>
  )
}

export default IndexPage;
export const imageData = graphql`
  query {
    images: allFile(filter: {relativePath: {glob: "portfolio/fullsize/*.jpg"}}, sort: {fields: name}) {
      edges {
        node {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
